<template>
    <v-content>
        <v-container fluid grid-list-lg>
            <v-layout row wrap>
                    <v-flex v-bind:key="match['.key']" xs12>
                        <v-card class="white--text">
                            <v-card-title primary-title>
                                <div>
                                    <h3 class="headline mb-0">{{ match.description }}
                                       </h3>
                                    <div>{{match.places - match.placesSold}} aantal plaatsen vrij, {{match.placesSold}} plaatsen verkocht</div>
                                </div>
                            </v-card-title>
                        </v-card>
                    </v-flex>
            </v-layout>
        </v-container>
        <v-container fluid grid-list-lg>
            <v-layout row wrap>
                <template v-for="tribune in match.tribunes">
                    <v-flex v-bind:key="tribune.tribuneKey" xs6>
                        <v-card color="blue-grey darken-2" class="white--text">
                            <v-card-title primary-title>
                                <div>
                                    <h3 class="headline mb-0">{{ tribune.description }} (Blok {{ tribune.block }})</h3>
                                    <div>{{tribune.places}}/{{tribune.places - tribune.placesSold - (tribune.placesReserved || 0)}} plaatsen vrij</div>
                                </div>
                            </v-card-title>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn flat dark @click="() => { selectTickets(tribune) }">Koop</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </template>
            </v-layout>
        </v-container>
        <TicketSelectionDialog
                :dialog="dialog"
                v-on:closeDialog="dialog = false"
                :selectedTribune="selectedTribune"
                @buyTickets="buyTickets"
                @selectSeats="selectSeats"
                :tribuneType="selectedTribuneType"
                :reservedSeats="reservedSeats"
        />
        <SeatSelectionDialog
                :dialog="seatDialog"
                v-on:closeDialog="seatDialog = false"
                :selectedTribune="selectedTribune"
                :selectedTribuneKey="selectedTribuneKey"
                @buyTickets="buyTickets"
                :tribuneSeats="selectedTribuneSeats"
                :tickets="tickets"
                :reservedSeats="reservedSeats"
        />
    </v-content>
</template>

<script>
import { db } from "../../firebase";
import TicketSelectionDialog from "../components/TicketSelectionDialog";
import printTickets from "../ticketPrinter";
import SeatSelectionDialog from "../components/SeatSelectionDialog";
import tribunes from "../tribunes";

export default {
  name: "Match",
  components: { SeatSelectionDialog, TicketSelectionDialog },
  props: {
    id: String
  },
  data() {
    return {
      match: {},
      matchKey: null,
      dialog: false,
      seatDialog: false,
      selectedTribune: null,
      selectedTribuneKey: null,
      selectedTribuneSeats: tribunes.tribuneB,
      tickets: null,
      subscriptionReservedSeats: []
    };
  },
  computed: {
    selectedTribuneType: function() {
      return this.selectedTribune ? this.selectedTribune.type : "stand";
    },
    reservedSeats: function() {
      if (
        this.match.tribunes &&
        this.match.tribunes[this.selectedTribuneKey] &&
        this.match.tribunes[this.selectedTribuneKey].seatsSold
      ) {
        return (
          this.match.tribunes[this.selectedTribuneKey].seatsSold.concat(
            this.subscriptionReservedSeats
          ) || this.subscriptionReservedSeats
        );
      }

      return this.subscriptionReservedSeats;
    }
  },
  mounted() {
    this.fetchMatch();
  },
  methods: {
    setReservedSeats: function(tribuneKey) {
      this.subscriptionReservedSeats = [];
      if (this.match.type === "regular") {
        db.collection("subscriptions")
          .where("tribune", "==", tribuneKey)
          .get()
          .then(subscriptions => {
            subscriptions.forEach(subscription => {
              this.subscriptionReservedSeats.push(subscription.data().tribuneSeat);
            });
          });
      }
    },
    fetchMatch: function() {
      db.collection("matches")
        .doc(this.$route.params.id)
        .get()
        .then(match => {
          this.match = match.data();
          const tribunesHandled = [];
          db.collection("subscriptions")
            .get()
            .then(subscriptions => {
              subscriptions.forEach(subscription => {
                const subscriptionData = subscription.data();
                if (tribunesHandled.indexOf(subscriptionData.tribune) === -1) {
                  this.match.tribunes[subscriptionData.tribune].placesReserved = 0;
                  tribunesHandled.push(subscriptionData.tribune);
                }
                this.match.tribunes[subscriptionData.tribune].placesReserved += 1;
              });
            });
        });
    },
    fetchTribune: function(tribune) {
      db.collection("tribunes")
        .doc(tribune.tribuneKey)
        .get()
        .then(tribune => {
          this.selectedTribune = tribune.data();
          this.selectedTribuneKey = tribune.id;
          this.selectedTribuneSeats = tribunes[tribune.data().block];
        });
    },
    buildTicketData(key, match, tribune, tribuneKey, row, seat) {
      const priceType = key.split("_")[1];
      const ticket = {
        matchKey: this.$route.params.id,
        description: match.description,
        type: tribune.type,
        tribune: tribune.description,
        tribuneKey: tribuneKey,
        block: tribune.block,
        date: new Date(),
        price: tribune["price_" + priceType],
        price_type: priceType,
        row: row,
        seat: seat
      };

      return ticket;
    },
    selectTickets: function(tribune) {
      this.selectedTribune = tribune;
      this.selectedTribuneKey = tribune.tribuneKey;
      this.selectedTribuneSeats = tribunes[tribune.block];
      this.setReservedSeats(tribune.tribuneKey);
      this.fetchTribune(tribune); // Update prices
      this.dialog = !this.dialog;
    },
    registerTickets: function(tickets) {
      let placesSold = 0;
      const newTickets = {};
      const updatedTribunes = { ...this.match.tribunes };
      const selectedSeats = tickets["selectedSeats"] || [];
      const seatsSold =
        updatedTribunes[this.selectedTribuneKey]["seatsSold"] || [];

      Object.keys(tickets).forEach(key => {
        if (key !== "selectedSeats" && tickets[key] > 0) {
          placesSold = placesSold + tickets[key];
          let seat = updatedTribunes[this.selectedTribuneKey]["placesSold"];
          for (let i = 0; i < tickets[key]; i++) {
            let selectedSeat = null;
            if (selectedSeats.length > 0) {
              selectedSeat = selectedSeats.pop();
              seatsSold.push(selectedSeat.seat);
            } else {
              seat = seat + 1;
            }

            const ticketData = this.buildTicketData(
              key,
              this.match,
              this.selectedTribune,
              this.selectedTribuneKey,
              selectedSeat ? selectedSeat.row : 0,
              selectedSeat ? selectedSeat.seat : seat
            );
            const newTicketRef = db.collection("tickets").doc();
            const newKey = newTicketRef.id;
            newTicketRef.set(ticketData);
            newTickets[newKey] = ticketData;
          }
        }
      });

      updatedTribunes[this.selectedTribuneKey]["placesSold"] += placesSold;
      updatedTribunes[this.selectedTribuneKey]["seatsSold"] = seatsSold;
      db.collection("matches")
        .doc(this.$route.params.id)
        .update({
          placesSold: this.match.placesSold + placesSold,
          tribunes: updatedTribunes
        });
      this.fetchMatch();

      return newTickets;
    },
    buyTickets: function(tickets) {
      tickets = this.registerTickets(tickets);
      printTickets(
        tickets,
        this.match.hometeam,
        this.match.description,
        this.match.date.toDate(),
        this.selectedTribune.description,
        this.selectedTribune.block
      );
      this.dialog = false;
      this.seatDialog = false;
      this.tickets = null;
    },
    selectSeats: function(tickets) {
      this.dialog = false;
      this.seatDialog = true;
      this.tickets = tickets;
    }
  }
};
</script>
